import produce from 'immer';
import {
  REQUEST_DWH_STATUS,
} from './constants';
import { REQUEST_DATA_RESULT } from "../../containers/App/constants";

export const initialState = {
  dwhStatus: { reports: [] },
};

export const toolsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_DWH_STATUS:
            draft.dwhStatus = action.result;
        }
    }
  });
